import React from 'react';
import { Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useOfflineContext } from 'context/OfflineContext';

const OfflineBanner: React.FC = () => {
  const { isOffline } = useOfflineContext();
  const { t } = useTranslation('common');

  if (!isOffline) return null;

  return (
    <Alert severity="warning" sx={{ borderRadius: 0 }}>
      {t('feedback.offline')}
    </Alert>
  );
};

export default OfflineBanner;
